package ru.malygin.urls.tech

/**
 * @param baseUrl зачистую не используется
 * @param apiAccess значени OPEN или CLOSE
 * @param apiVersion версия API
 * @param apiPath путь к вызываемому методу API
 *
 * @property urlOpen конечный URL для запроса
 */
data class UrlParams(
    val baseUrl: String = "",
    val apiAccess: ApiAccess = ApiAccess.CLOSE,
    val apiVersion: ApiVersion = ApiVersion.V1,
    val apiPath: String,
    ){

    private val urlBuildBase = baseUrl + apiAccess.value + apiVersion.value

    val urlOpen = urlBuildBase + apiPath

    companion object{
        private const val API_OPEN = "/api/open"
        private const val API_CLOSE = "/api/close"

        private const val V_1 = "/v1"

        enum class ApiAccess(
            val value: String,
        ) {
            OPEN(API_OPEN),
            CLOSE(API_CLOSE)
        }

        enum class ApiVersion(
            val value: String,
        ){
            V1(V_1),
        }
    }
}